import React from "react";
import LandingPage from "../components/layouts/LandingPage";
import { Box, Button, Container, Grid, Paper } from "@mui/material";
import "../assets/css/comman.css";
import { Helmet } from "react-helmet";
import CommercialCladdingCalgaryLanding from "../assets/images/The-Thermal-Systems-Maintenance-Story.webp"
import CladdingRepairCalgary from "../assets/images/Commercial-Cladding-Repair-Calgary.webp"

const CommercialCladdingRepairCalgary = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Façade Repairs | Commercial Cladding Repair Calgary | Thermal Systems</title>
        <meta
          name="description"
          content="Serving Calgary for several decades, Thermal Systems offers a Commercial Cladding Repairs that keep your business looking its best."
        />
      </Helmet>
      <LandingPage
        landingImg={CommercialCladdingCalgaryLanding}
        heading="COMMERCIAL CLADDING REPAIR CALGARY"
      />
      <Container sx={{ padding: "30px", marginBottom: "30px" }}>
        <Paper elevation={2}>
          <Box className="main">
            <div>
              <div className="heading">
                <p>
                  Trust Thermal Systems for your Commercial Cladding Repairs in
                  Calgary
                </p>
              </div>
              <div className="decoration">
                <div className="decoration-inside"></div>
              </div>
              <Container>
                <p  className="justify-content">
                  It’s not the Death Star but it IS your home office, so it
                  needs to look great.After all, your cladding makes the first
                  impression your potential clients see, so it is important that
                  it looks the best it can. At Thermal Systems we not only
                  clean, but we also make Commercial Cladding Repairs throughout
                  Calgary and the surrounding area.
                </p>

                <Grid container spacing={2} sx={{ alignItems: "center" }}>
                  <Grid item xs={12} md={4} sm={12}>
                    <img style={{width:"100%"}} src={CladdingRepairCalgary} alt="commercialcladdingrepaircalgary"/>
                  </Grid>
                  <Grid item xs={12} md={8} lg={8} sm={8}>
                    <h2 className="h2-heading">
                      Cladding Puts Your Best Foot Forward for In-person and
                      Online Clients
                    </h2>
                    <p style={{ marginTop: "0px" }}  className="justify-content">
                      Your façade is the face of your company, and you only get
                      one chance to make a first impression. Once upon a time
                      that only meant physical visits to your office. Nowadays
                      it means people being able to see your business on <a href="https://www.google.ca/maps/place/261185+Wagon+Wheel+Way,+Airdrie,+AB+T4A+0E2,+Canada/@51.2081491,-113.9683878,17z/data=!3m1!4b1!4m6!3m5!1s0x5371604fe4a534fb:0x18ddb37b8978323e!8m2!3d51.2081491!4d-113.9683878!16s%2Fg%2F11c0qgrr_g?entry=ttu">Google
                      Maps </a>and other places on the internet. So, if you have
                      dented or dirty cladding, potential customers may go
                      elsewhere, whether they see your cladding in-person or
                      online. In this online world, even B2B can come down to
                      “swipe left, swipe right”, so you need to put your best
                      foot forward. Always.
                    </p>
                  </Grid>
                </Grid>
                <h2 className="h2-heading">
                  Your Cladding Is Not Unlike Your Roof – Protect Your
                  Investments
                </h2>
                <p  className="justify-content">
                  When you take care of your cladding, you protect your building
                  and everything inside it. Calgary has rough weather sometimes,
                  and as they say, an ounce of prevention is worth a pound of
                  cure. That means that things like caulking, dent repair and
                  even simple cleaning can prevent major damage from occurring.
                  As a result, preventative maintenance and commercial cladding
                  repair in Calgary has become more and more common.
                </p>
                <h2 className="h2-heading">
                  Thermal Systems Repairs All Types of Commercial Cladding
                </h2>
                <p  className="justify-content">
                  The team of professionals at Thermal Systems has decades of
                  experience performing commercial cladding repair. We
                  constantly keep abreast of new methods of cladding restoration
                  and repairs and are known as leaders in the industry. We can
                  repair damage caused by the sun, vandalism, or general wear
                  and tear, and restore all types of cladding materials.
                </p>
                <p  className="justify-content">
                  Working closely with our system partner, <a href="https://www.rheinzink.com/products/">RHEINZINK®</a> the
                  world's leading manufacturer of titanium and zinc products,
                  and repair all types of <a href="/services/commercial-roofing-maintenance-repairs">architectural metals</a>, including:
                </p>
                <div>
                  <ul>
                    <li>Steel</li>
                  </ul>
                  <ul>
                    <li>Stainless Steel</li>
                  </ul>
                  <ul>
                    <li>Titanium</li>
                  </ul>
                  <ul>
                    <li>Aluminum</li>
                  </ul>
                  <ul>
                    <li>Copper</li>
                  </ul>
                  <ul>
                    <li>Zinc</li>
                  </ul>
                  <ul>
                    <li>Titanium</li>
                  </ul>
                </div>

                <h2 className="h2-heading">
                  Your Commercial Cladding Repairs Begin with a Visual
                  Inspection
                </h2>
                <p  className="justify-content">
                  Once you choose Thermal Systems for your cladding repairs, we
                  will conduct a thorough visual inspection of your
                  cladding.Once that is completed, we will provide a detailed
                  report of our findings and recommendations for permanent
                  repairs on area(s) of concern. We also work together with
                  engineers and consultants when more extensive repairs are
                  identified and work on permanent solutions has begun.Our
                  cladding maintenance and repair services include:
                </p>
                <div>
                  <ul>
                    <li>
                      Emergency cladding and panel repairs, replacements and/or
                      removals
                    </li>
                  </ul>
                  <ul>
                    <li>
                      Architectural panel and metal cladding repairs and
                      replacements for all size projects
                    </li>
                  </ul>
                  <ul>
                    <li>
                      Architectural panel and cladding cleaning, including
                      pressure washing
                    </li>
                  </ul>
                  <ul>
                    <li>
                      Insulation repairs and/or replacements, including those
                      related to mould, R-value concerns, thermal bridging
                    </li>
                  </ul>
                  <ul>
                    <li>Caulking and sealing repairs</li>
                  </ul>
                </div>
                <h2 className="h2-heading">
                Your Cladding Works Hard: We Work Harder to Keep It in Tip-top Shape
                </h2>
                <p  className="justify-content">
                While building cladding is in many ways the face of your company, it is also an important player when it comes to protecting your building and everything inside it. At Thermal Systems we can quickly diagnose and repair and provide permanent solutions to any damage or deficiencies your cladding may have.
                </p>
                <p  className="justify-content">
                We work with commercial clients throughout Calgary and also offer cladding cleaning and preventative maintenance.
                </p>
              </Container>
            </div>
          </Box>
          <Container className="message">
            <h2 className="h2-heading">
              <a href="/contact">
                Contact us today to ensure that your cladding continues to shine
                the best possible light on your company.
              </a>
            </h2>
          </Container>
          <Grid item xs={12} className="textfieldgrid">
            <Button
              variant="contained"
              sx={{ backgroundColor: "#D13139", marginBottom: "60px" }}
              href="/contact"
              >
              CONTACT US
            </Button>
          </Grid>
        </Paper>
      </Container>
    </>
  );
};

export default CommercialCladdingRepairCalgary;
